import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const letterIndex = (theme: Theme) => css`
  display: flex;
  height: 36px;
  gap: 4px;

  > * {
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    color: ${theme.palette.blue.main};
    background-color: ${theme.palette.white.main};
    user-select: none;
    cursor: pointer;
    transition:
      background-color 0.1s ease,
      box-shadow 0.1s ease;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
    }

    &:active {
      background-color: ${theme.palette.white.main}80;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
    }

    &.selected {
      border-radius: 1px;
      background-color: ${theme.palette.uintel.main};
      color: ${theme.palette.white.main};
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
    }
    &.disabled {
      color: ${theme.palette.grey[400]};
      cursor: not-allowed;
      pointer-events: none;
    }
  }
`

export const glossaryContents = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 64px;
  gap: ${theme.spacing(20)};
  position: absolute;
  top: 24px;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: auto;

  h1 {
    margin-top: 0;
    color: ${theme.palette.uintel.light};
    font-size: 40px;
    font-weight: 700;
    line-height: 1.2;
  }

  > * > .glossary-row {
    padding: 16px 8px;
    display: flex;
  }

  > * > .glossary-row.no-plain {
    border-bottom: 1px solid ${theme.palette.uintel.light};
  }

  .glossary-term {
    color: ${theme.palette.uintel.light};
    font-weight: 700;
    margin-left: 8px;
    width: 280px;
    flex-shrink: 0;
  }

  .glossary-definition {
    line-height: 160%;
    flex-grow: 1;
  }
`

export const glossaryContentsOuter = css`
  position: relative;
  width: 100%;
  flex-grow: 1;
`

export const plainDefinitionContainer = (theme: Theme) => css`
  color: ${theme.palette.uintel.light};
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  border-bottom: 1px solid ${theme.palette.uintel.light};
`

export const plainDefinitionLabel = (theme: Theme) => css`
  color: ${theme.palette.uintel.light};
  font-weight: 700;
  margin-left: 24px;
  width: 280px;
  flex-shrink: 0;
  font-style: italic;
`

export const plainDefinition = (theme: Theme) => css`
  line-height: 160%;
  flex-grow: 1;
  color: ${theme.palette.black.main};
`
export const rootContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  height: 100%;
  padding-left: 0;
  padding-right: 0;
`

export const letterIndexWrapper = css`
  width: 100%;
  padding-left: 0;
  padding-right: 0;
`

export const glossaryRow = css`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding-left: 16px;
`
